module.exports = __webpack_public_path__ + "static/media/tea_cups.1339191a.png";